import React from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthService } from "../../services/auth.service";

const PrivateRoute = ({ component: Component, roles, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const currentUser = AuthService.currentUserValue;
      const currentUserToken = AuthService.currentUserToken;
      // console.log("current user", currentUser);
      // console.log("currentToken", currentUserToken);
      if (
        !currentUser ||
        !Object.values(currentUser).length ||
        !currentUserToken
      ) {
        // not logged in so redirect to login page with the return url
        console.log("Not logged in");
        return <Redirect to={{ pathname: "/login" }} />;
      }

      if (roles && roles.indexOf(currentUser.roleId) === -1) {
        console.log("role not authorized");
        // role not authorised so redirect to home page
        return <Redirect to={{ pathname: "/dashboard" }} />;
        // window.location.reload();
      }

      // authorized so return component
      return <Component {...props} />;
    }}
  />
);

export default PrivateRoute;
